/* eslint-disable no-console */
import {Divider} from 'antd';
import React, {useEffect, useState} from 'react';
import {useSearchParams} from 'react-router-dom';

import BlockAccessPage from '../../../../components/BlockAccess/BlockAccessPage';
import Loader from '../../../../components/Loader/Loader';
import {checkIfHasPermissions} from '../../../../components/Menu/Utils/commonFunctions';
import PageContent from '../../../../components/PageContent/PageContent';
// import ProductInfo from '../../../../components/Table/ProductInfoTable';
import MainTableTitle from '../../../../components/Table/Utils/MainTableTitle';
import Tabs from '../../../../components/Tabs/Tabs';
import {PermissionEnum} from '../../../../constants/permissionsEnum';
import {Itabs} from '../../../../interface/Tab';
import TranslatedText from '../../../../libraries/I18N/TranslatedText';
import {APITypeEnum} from '../../../../services/interface/tableAPIType';
import productsJSON from '../../../../services/modules/JSON/products';
import rawMaterialJson from '../../../../services/modules/JSON/rawMaterial';
import facilityDetails from '../../../../services/modules/OM/facilityDetails';
import Year from '../../../../shared/Year';
import {accessModule} from '../../../../store/companyStore/companyDetailsStore';
import {checkCurrentYearOrBelow} from '../../../../utils/commonFunctions';
// import {yearSelect} from '../../../../utils/FormUtils/yearSelect';
import {shouldBlockModuleAccess} from '../../../../utils/SubscriptionHelper';

import EndLifeCycle from './Utils/EndLifeCycle';
import Processing from './Utils/Processing';
import RawMaterial from './Utils/RawMaterial';
import SoldProducts from './Utils/SoldProducts';

const Products: React.FC = () => {
  const [searchParam, setSearchParams] = useSearchParams();
  const [isLoading, setIsLoading] = useState(true);
  const [selectedYear, setSelectedYear] = useState('');

  const ProductTab: Itabs[] = [
    // {
    //   id: 'productInfo',
    //   name: <TranslatedText translationKey="Product Info" />,
    //   component: <ProductInfo selectedYear={selectedYear} />
    // },
    {
      id: 'rawMaterial',
      name: <TranslatedText translationKey="Raw Material" />,
      component: <RawMaterial selectedYear={selectedYear} />,
      hidden: !checkIfHasPermissions(
        PermissionEnum.OrgManagerProductRawMaterial
      )
    },
    {
      id: 'processing',
      name: (
        <TranslatedText translationKey="Processing of Sold Products (B2B)" />
      ),
      component: <Processing selectedYear={selectedYear} />,
      hidden: !checkIfHasPermissions(
        PermissionEnum.OrgManagerProductProcessingOfSoldProduct
      )
    },
    {
      id: 'soldProducts',
      name: <TranslatedText translationKey="Use of Sold Products (B2C)" />,
      component: <SoldProducts selectedYear={selectedYear} />,
      hidden: !checkIfHasPermissions(
        PermissionEnum.OrgManagerProductUseOfSoldProducts
      )
    },
    {
      id: 'endOfLife_scope3',
      name: <TranslatedText translationKey="End of Life Treatment" />,
      component: shouldBlockModuleAccess(accessModule.scope3) ? (
        <BlockAccessPage />
      ) : (
        <EndLifeCycle selectedYear={selectedYear} />
      ),
      hidden: !checkIfHasPermissions(PermissionEnum.OrgManagerEOLT)
    }
  ].filter((item) => !item.hidden);

  // const firstYear = yearSelect();

  useEffect(() => {
    const currentYear = checkCurrentYearOrBelow(
      searchParam.get('selectedYear')
    );
    searchParam.set('selectedYear', currentYear);
    setSearchParams(searchParam);
    setSelectedYear(currentYear);
    Promise.all([
      productsJSON(),
      facilityDetails(APITypeEnum.GET_ALL, false),
      rawMaterialJson()
    ])

      .catch(() => {})
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  return (
    <PageContent>
      {isLoading ? (
        <Loader />
      ) : (
        selectedYear && (
          <>
            <MainTableTitle title="Product Lifecycle" />
            <Year setSelectedYear={setSelectedYear} />
            <Divider />
            <Tabs array={ProductTab} />
          </>
        )
      )}
    </PageContent>
  );
};

export default Products;
